import bronzeBadge from '@/assets/images/bronze-badge.svg';
import diamondBadge from '@/assets/images/diamond-badge.svg';
import goldBadge from '@/assets/images/gold-badge.svg';
import ironBadge from '@/assets/images/iron-badge.svg';
import legendaryBadge from '@/assets/images/legendary-badge.svg';
import platinumBadge from '@/assets/images/platinum-badge.svg';
import silverBadge from '@/assets/images/silver-badge.svg';
import { getUserLevelByCurrentXp } from '@/screens/home/action/userDetails';

const levelUpCarouselItems = [
  {
    id: 1,
    name: 'Iron',
    icon: ironBadge,
    progressColor: 'bg-[#6D8192]',
    textColor: 'text-[#6D8192]',
  },
  {
    id: 2,
    name: 'Bronze',
    icon: bronzeBadge,
    progressColor: 'bg-[#B8531B]',
    textColor: 'text-[#B8531B]',
  },
  {
    id: 3,
    name: 'Silver',
    icon: silverBadge,
    progressColor: 'bg-[#A8B3CF]',
    textColor: 'text-[#A8B3CF]',
  },
  {
    id: 4,
    name: 'Gold',
    icon: goldBadge,
    progressColor: 'bg-[#FF8E3B]',
    textColor: 'text-[#FF8E3B]',
  },
  {
    id: 5,
    name: 'Platinum',
    icon: platinumBadge,
    progressColor: 'bg-[#2CDCE6]',
    textColor: 'text-[#2CDCE6]',
  },
  {
    id: 6,
    name: 'Diamond',
    icon: diamondBadge,
    progressColor: 'bg-[#7147ED]',
    textColor: 'text-[#7147ED]',
  },
  {
    id: 7,
    name: 'Legendary',
    icon: legendaryBadge,
    progressColor: 'bg-[#E04337]',
    textColor: 'text-[#E04337]',
  },
];

type LevelData = {
  id: number;
  name?: string;
  icon?: string;
  progressColor?: string;
  textColor?: string;
  completed: boolean;
  active?: boolean;
  percentCompleted?: number;
};

type CarouselData = LevelData[];

export const updateLevelUpCarousalItems = (idToUpdate: number, newItem: any) => {
  const updatedItems: CarouselData = levelUpCarouselItems.map(item => {
    if (item?.id === idToUpdate) {
      return { ...item, ...newItem };
    }
    if (item.id < idToUpdate) {
      return { ...item, completed: true };
    }
    return item;
  });
  return updatedItems;
};

const percentCompletedValue = (
  startingPoint: number,
  endPoint: number,
  currentPoint: number
): number => {
  const x = currentPoint - startingPoint;
  const y = endPoint - startingPoint;
  return (x / y) * 100;
};

export const getActiveBadgeData = async (point: number) => {
  const getBadgeData = (id: number, startingPoint: number, endPoint: number): LevelData => {
    const percentCompleted = percentCompletedValue(startingPoint, endPoint, point);

    return {
      id,
      completed: percentCompleted >= 100,
      active: true,
      percentCompleted,
    };
  };

  const userLevel: any = await getUserLevelByCurrentXp(point);
  return getBadgeData(userLevel?.level, userLevel?.startPoint, userLevel?.endPoint);
  // if (point < 10) return getBadgeData(1, 1, 10) // Iron badge points between 1 and 10
  // if (point < 20) return getBadgeData(2, 10, 20) // Bronze badge points between 10 and 20
  // if (point < 40) return getBadgeData(3, 20, 40) // Silver badge points between 20 and 40
  // if (point < 60) return getBadgeData(4, 40, 60) // Gold badge points between 40 and 60
  // if (point < 80) return getBadgeData(5, 60, 80) // Platinum badge points between 60 and 80
  // if (point < 100) return getBadgeData(6, 80, 100) // Diamond badge points between 80 and 100
  // if (point <= 150) return getBadgeData(7, 100, 150) // legendary badge points between 100 and 150

  // return { id: 0, completed: false }
};
